<template>
	<div class="ttshop_user">
		<Header></Header>
		<Userheader></Userheader>
		<div class="ttshop_user">
			<div class="ttshop_usercon w clearfloat">
				<!-- 个人中心导航 -->
				<Usernavleft></Usernavleft>
				<div class="ttshop_useright">
					<!-- 关注的店铺 -->
					<div class="ttshop_coupon min_h">
						<!-- 暂无关注店铺时显示 -->
						<div class="ttshop_zwsc">
							<img src="../../assets/images/ttshop_sc.png" alt="">
							<p>暂无关注任何店铺</p>
						</div>
						<!-- 关注店铺列表 -->
						<div class="ttshop_store">
							<div class="ttshop_storelist clearfloat" v-for="(item,index) in 4" :key="index">
								<div class="ttshop_storeleft">
									<div class="ttshop_storetop clearfloat">
										<p>置顶</p>
										<p>取消关注</p>
									</div>
									<div class="ttshop_storeleftimg">
										<img src="../../assets/images/goods_1.png" alt="">
									</div>
									<div class="ttshop_storeleftext">
										<h5>GXG官方旗舰店</h5>
										<div class="ttshop_storepf clearfloat d-flex justify-content-center">
											<span>服务体验</span>
											<div class="ttshop_evaluatenums">
												<el-rate
												  v-model="value"
												  disabled
												  score-template="{value}">
												</el-rate>
											</div>
										</div>
										<p>粉丝:<span>52293</span></p>
										<div class="ttshop_storebut clearfloat">
											<router-link to="#">进入店铺</router-link>
											<router-link to="#">联系客服</router-link>
										</div>
									</div>
								</div>
								<div class="ttshop_storeright">
									<div class="ttshop_storetab clearfloat">
										<p class="active">热销</p>
										<p>新品</p>
									</div>
									<div class="ttshop_storerightlist clearfloat">
										<ul class="clearfloat">
											<li>
												<div class="ttshop_storeimg">
													<img src="../../assets/images/goods_1.png" alt="">
												</div>
												<div class="ttshop_storetext">
													<h5>七匹狼T恤男士翻领纯棉短袖2020夏季新款</h5>
													<p>￥69.00</p>
												</div>
											</li>
											<li>
												<div class="ttshop_storeimg">
													<img src="../../assets/images/goods_1.png" alt="">
												</div>
												<div class="ttshop_storetext">
													<h5>七匹狼T恤男士翻领纯棉短袖2020夏季新款</h5>
													<p>￥69.00</p>
												</div>
											</li>
											<li>
												<div class="ttshop_storeimg">
													<img src="../../assets/images/goods_1.png" alt="">
												</div>
												<div class="ttshop_storetext">
													<h5>七匹狼T恤男士翻领纯棉短袖2020夏季新款</h5>
													<p>￥69.00</p>
												</div>
											</li>
											<li>
												<div class="ttshop_storeimg">
													<img src="../../assets/images/goods_1.png" alt="">
												</div>
												<div class="ttshop_storetext">
													<h5>七匹狼T恤男士翻领纯棉短袖2020夏季新款</h5>
													<p>￥69.00</p>
												</div>
											</li>
											<li>
												<div class="ttshop_storeimg">
													<img src="../../assets/images/goods_1.png" alt="">
												</div>
												<div class="ttshop_storetext">
													<h5>七匹狼T恤男士翻领纯棉短袖2020夏季新款</h5>
													<p>￥69.00</p>
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div class="ttshop_myorderpage clearfloat">
							<el-pagination class="ttshop_pages" background layout="prev, pager, next" :total="40"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Foot from "@/components/foot/foot";
	import Userheader from "./components/user_index";
	import Usernavleft from "./components/user_navleft";
	export default {
		components: {
			Header,
			Userheader,
			Usernavleft,
			Foot,
		},
		data() {
			return {
				value: 4
			}
		},
		mounted() {

		},
		methods: {

		}
	};
</script>

<style lang="scss" scoped>
	.ttshop_coupon {
		width: 100%;
		background: #fff;
		padding: 20px;
		box-sizing: border-box;
		.ttshop_zwsc {
			width: 100%;
			padding-top: 200px;
			box-sizing: border-box;
			display: none;
			img {
				display: block;
				width: 85px;
				height: 80px;
				margin: 0 auto 20px;
			}
			p {
				font-size: 16px;
				color: #333;
				text-align: center;
			}
		}
		.ttshop_store{
			width: 100%;
			.ttshop_storelist{
				width: 100%;
				border: 1px solid #EBEBEB;
				box-sizing: border-box;
				height: 318px;
				margin-bottom: 16px;
				.ttshop_storeleft{
					float: left;
					width: 220px;
					border-right: 1px solid #EBEBEB;
					padding-top: 40px;
					box-sizing: border-box;
					height: 318px;
					position: relative;
					overflow: hidden;
					&:hover .ttshop_storetop{top: 0;}
					.ttshop_storetop{
						width: 100%;
						position: absolute;
						top: -34px;
						left: 0;
						transition: .5s;
						-moz-transition: .5s;
						-webkit-transition: .5s;
						-o-transition: .5s;
						p{
							position: relative;
							width: 50%;
							float: left;
							height: 34px;
							text-align: center;
							line-height: 34px;
							cursor: pointer;
							background: #999999;
							font-size: 12px;
							color: #fff;
							transition: .5s;
							-moz-transition: .5s;
							-webkit-transition: .5s;
							-o-transition: .5s;
							&::before{
								content: "";
								width: 1px;
								height: 34px;
								background: #fff;
								position: absolute;
								top: 0;
								right: 0;
							}
							&:last-child:before{display: none;}
							&:hover{background: #FF0E25;}
						}
					}
					.ttshop_storeleftimg{
						width: 100px;
						height: 100px;
						margin: 0 auto 24px;
						img{
							display: block;
							width: 100%;
							height: 100%;
							object-fit: cover;
						}
					}
					.ttshop_storeleftext{
						width: 100%;
						padding: 0 10px;
						box-sizing: border-box;
						h5{
							font-size: 14px;
							color: #333;
							line-height: 14px;
							font-weight: 600;
							text-align: center;
							overflow: hidden;
							text-overflow:ellipsis;
							white-space: nowrap;
							margin-bottom: 10px;
						}
						.ttshop_storepf{
							width: 100%;
							margin-bottom: 18px;
							span{
								float: left;
								font-size: 12px;
								color: #333;
								line-height: 18px;
								margin-right: 8px;
							}
						}
						p{
							font-size: 12px;
							color: #333;
							text-align: center;
							font-weight: 400;
							line-height: 12px;
							margin-bottom: 16px;
						}
						.ttshop_storebut{
							width: 100%;
							padding: 0 14px;
							box-sizing: border-box;
							a{
								float: left;
								width: 75px;
								height: 28px;
								color: #FF0E25;
								font-size: 12px;
								text-align: center;
								line-height: 28px;
								border-radius: 2px;
								border: 1px solid #FF0E25;
								margin-right: 16px;
								&:last-child{
									border-color: #FF9010;
									color: #FF9010;
									margin-right: 0;
								}
							}
						}
					}
				}
				.ttshop_storeright{
					float: left;
					width: 728px;
					height: 318px;
					padding: 23px 21px;
					box-sizing: border-box;
					.ttshop_storetab{
						width: 100%;
						margin-bottom: 19px;
						p{
							float: left;
							width: 80px;
							height: 28px;
							text-align: center;
							line-height: 26px;
							font-size: 12px;
							color: #FF0E25;
							border-radius: 2px 0 0 2px;
							border: 1px solid #FF0E25;
							box-sizing: border-box;
							transition: .5s;
							-moz-transition: .5s;
							-webkit-transition: .5s;
							-o-transition: .5s;
							background: #fff;
							cursor: pointer;
							&:last-child{border-radius: 0 2px 2px 0;}
							&.active{background: #FF0E25;color: #fff;}
							&:hover{background: #FF0E25;color: #fff;}
						}
					}
					.ttshop_storerightlist{
						width: 100%;
						ul{
							li{
								float: left;
								width: 121px;
								margin-right: 20px;
								cursor: pointer;
								&:last-child{margin-right: 0;}
								&:hover .ttshop_storeimg img{
									-webkit-transform: scale(1.1);
									-moz-transform: scale(1.1);
									-o-transform: scale(1.1);
									-ms-transform: scale(1.1);
									transform: scale(1.1);
								}
								&:hover .ttshop_storetext h5{
									color: #FF0E25;
								}
								.ttshop_storeimg{
									width: 100%;
									height: 121px;
									margin-bottom: 16px;
									overflow: hidden;
									img{
										display: block;
										width: 100%;
										height: 100%;
										object-fit: cover;
										transition: .5s;
										-moz-transition: .5s;
										-webkit-transition: .5s;
										-o-transition: .5s;
									}
								}
								.ttshop_storetext{
									width: 100%;
									h5{
										font-size: 12px;
										color: #666;
										font-weight: 400;
										line-height: 18px;
										height: 36px;
										display: -webkit-box;
										-webkit-box-orient: vertical;
										-webkit-line-clamp: 2;
										overflow: hidden;
										margin-bottom: 15px;
										transition: .5s;
										-moz-transition: .5s;
										-webkit-transition: .5s;
										-o-transition: .5s;
									}
									p{
										font-size: 16px;
										color: #FF0E25;
										font-weight: 500;
										line-height: 16px;
									}
								}
							}
						}
					}
				}
			}
		}
		.ttshop_myorderpage{
			width: 100%;
			margin-top: 32px;
			.ttshop_pages{
				float: right;
			}
		}
	}
</style>
